var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[(_vm.url)?_c('img',{staticClass:"brand-logo",style:({'width': `${_vm.baseData.branding.logoImageSize}%`}),attrs:{"src":_vm.url,"alt":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }